module.exports = __webpack_public_path__ + "img/kuangjiao_xc6.90724a2a.jpg";